import { useEffect, useRef, useState } from 'react'
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { RiAdminLine } from "react-icons/ri";
import { ImCross } from "react-icons/im";
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../Providers/AuthProvider';
import { ResetPasswordType } from '../../Data/ResetPasswordTypeEnum.ts';
import LoadingSpinner from '../../Components/Components/LoadingSpinner.jsx';

const ResetPassword = () => {
    const activationCalled = useRef(false)
    const { handleResetPassword } = useAuth()
    const location = useLocation()
    const { email } = location.state || {}
    const [apiResult, setApiResult] = useState(null)

    useEffect(() => {
        reset()
    }, [])
    const reset = async () => {
        if (!activationCalled.current) {
            activationCalled.current = true
            const result = await handleResetPassword(email)
            setApiResult(result)
        }
    }
    if (apiResult === null) {
        return <LoadingSpinner />
    }
    return (
        <div className="container main-container-holder text-center" style={{ fontSize: '25px' }}>
            <div className="row mt-4">
                {generateImage(apiResult.resetType)}
            </div>
            <div className="row mt-4">
                <b style={{ fontSize: '30px' }}>{apiResult.message}</b>
            </div>
        </div>
    )
}

const generateImage = (resetType) => {
    if (resetType == ResetPasswordType.None) {
        return <ImCross size={150} className='error-text-color' />
    }
    else if (resetType == ResetPasswordType.ByAdmin) {
        return <RiAdminLine size={150} className='warning-text-color' />
    }
    else {
        return <MdOutlineMarkEmailRead size={150} color='var(--primary)' />
    }
}

export default ResetPassword